module.exports = __webpack_public_path__ + "static/media/img_order.3e5f12f6.png";